// extracted by mini-css-extract-plugin
export var adjacentSlide = "_ow-9";
export var arrowButtonContainer = "_ow-5";
export var arrowButtonIcon = "_ow-6";
export var carouselArrowButton = "_ow-2";
export var carouselElementContainer = "_ow-1";
export var currentSlide = "_ow-8";
export var left = "_ow-3";
export var otherSlide = "_ow-a";
export var productCarouselContainer = "_ow-0";
export var right = "_ow-4";
export var sliderOverflow = "_ow-7";